import type { ReactNode } from "react";

type ContainerProps = {
  children: ReactNode;
  className?: string;
  width?: "landing" | "legal" | "support";
};

const widthClass: Record<NonNullable<ContainerProps["width"]>, string> = {
  landing: "max-w-landing",
  legal: "max-w-legal",
  support: "max-w-support"
};

export function Container({ children, className = "", width = "landing" }: ContainerProps) {
  return <div className={`mx-auto w-full ${widthClass[width]} px-5 sm:px-8 ${className}`}>{children}</div>;
}
